<template>
  <nav class="au-sidebar" :aria-label="$t('nav.panel')">
    <div class="au-brand">
      <div class="au-brand-logo"><i class="bi bi-shield-lock-fill"></i></div>
      <div>
        <div class="au-brand-name">Vissonic</div>
        <div class="au-brand-sub">{{ $t("nav.panel") }}</div>
      </div>
    </div>

    <div class="au-nav-section">{{ $t("nav.management") }}</div>
    <router-link class="au-nav-item" :to="{ name: 'Dashboard' }" :title="$t('nav.dashboard')">
      <span class="au-nav-icon is-indigo"><i class="bi bi-grid-1x2-fill"></i></span>
      <span class="au-nav-label">{{ $t("nav.dashboard") }}</span>
    </router-link>
    <router-link v-if="isSuperAdmin || isDistributor" class="au-nav-item" :to="{ name: 'Clients' }"
      :title="$t('nav.clients')">
      <span class="au-nav-icon is-emerald"><i class="bi bi-briefcase-fill"></i></span>
      <span class="au-nav-label">{{ $t("nav.clients") }}</span>
    </router-link>

    <template v-if="isSuperAdmin">
      <div class="au-nav-section">{{ $t("nav.administration") }}</div>
      <router-link class="au-nav-item" :to="{ name: 'Distributors' }" :title="$t('nav.distributors')">
        <span class="au-nav-icon is-rose"><i class="bi bi-shop"></i></span>
        <span class="au-nav-label">{{ $t("nav.distributors") }}</span>
      </router-link>
      <router-link class="au-nav-item" :to="{ name: 'Users' }" :title="$t('nav.users')">
        <span class="au-nav-icon is-amber"><i class="bi bi-people-fill"></i></span>
        <span class="au-nav-label">{{ $t("nav.users") }}</span>
      </router-link>
    </template>

    <div class="au-user">
      <div class="au-user-avatar">{{ initials }}</div>
      <div style="min-width: 0;">
        <div class="au-user-name">{{ authStore.user?.fullName }}</div>
        <div class="au-user-role">{{ roleName }}</div>
      </div>
      <div class="au-user-actions">
        <button type="button" class="au-user-logout" :title="$t('account.changePassword')"
          :aria-label="$t('account.changePassword')" @click="showPasswordModal = true">
          <i class="bi bi-key"></i>
        </button>
        <button type="button" class="au-user-logout" :title="$t('nav.logout')" :aria-label="$t('nav.logout')"
          @click="logout">
          <i class="bi bi-box-arrow-right"></i>
        </button>
      </div>
    </div>

    <ChangeOwnPasswordModal :visible="showPasswordModal" @close="showPasswordModal = false" />
  </nav>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useAuthStore } from "@/stores/auth.store";
import { UserRole } from "@/enums/user-role.enum";
import ChangeOwnPasswordModal from "@/components/account/ChangeOwnPasswordModal.vue";

export default defineComponent({
  components: { ChangeOwnPasswordModal },
  setup() {
    const authStore = useAuthStore();
    const { t } = useI18n();
    const showPasswordModal = ref(false);

    const isSuperAdmin = computed(() => authStore.user?.role === UserRole.SuperAdmin);
    const isDistributor = computed(() => authStore.user?.role === UserRole.Distributor);

    const initials = computed(() => {
      const parts = (authStore.user?.fullName ?? "").trim().split(/\s+/).filter(part => part.length > 0);
      return parts.slice(0, 2).map(part => part[0].toUpperCase()).join("");
    });

    const roleName = computed(() => {
      const role = authStore.user?.role;
      return role ? t(`roles.${UserRole[role]}`) : "";
    });

    const logout = () => {
      authStore.logout();
    };

    return { authStore, isSuperAdmin, isDistributor, initials, roleName, showPasswordModal, logout };
  }
});
</script>
